<!-- Page Header End -->
<div class="container-xxl py-5 position-relative mb-5 page-header" [ngClass]="domain">
  <div class="container py-5">
    <h1 class="display-2 text-white animated slideInDown mb-4">
      {{
        pageOptions.children[pageOptions.children.length - 1].title | translate
      }}
    </h1>
    <nav aria-label="breadcrumb animated slideInDown">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a class="text-white" href="{{ pageOptions.mainPage.path }}">{{
            pageOptions.mainPage.title | translate
          }}</a>
        </li>
        <li *ngFor="let tab of pageOptions.children" class="breadcrumb-item">
          <a class="text-white" *ngIf="tab.path" href="{{ tab.path }}">{{
            tab.title | translate
          }}</a>
          <span *ngIf="!tab.path">{{ tab.title | translate }}</span>
        </li>
        <!-- <li class="breadcrumb-item text-white active" aria-current="page">
          {{ pageOptions.childPageTitle | translate }}
        </li> -->
      </ol>
    </nav>
  </div>
</div>
<!-- Page Header End -->
